import { render } from "./tablePaginationDark.vue?vue&type=template&id=c0e02032&scoped=true"
import script from "./tablePaginationDark.vue?vue&type=script&lang=js"
export * from "./tablePaginationDark.vue?vue&type=script&lang=js"

import "./tablePaginationDark.vue?vue&type=style&index=0&id=c0e02032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e02032"]])

export default __exports__